import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import Wrapper from "../../components/layout/Wrapper";
import NAV from "../../utils/nav.const";
import { useNavigate } from "react-router-dom";
import Email from "../../assets/images/svg/email.svg";
import LoginIcon from "@mui/icons-material/Login";
import theme from "../../styles/styleTheme";
import { useTranslation } from "react-i18next";

const AccountConfirmation = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        height={isSmallScreen ? "100vh" : "80vh"}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <img src={Email} height={260} alt="Verify Email" />
          </Grid>
          <Grid padding={2} item xs={12}>
            <Typography color="primary" variant="h1">
              Welcome Home!
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography padding={1} variant="subtitle2" dangerouslySetInnerHTML={{ __html: t("createdProfile.basic.text") }} />
          </Grid>
          <Grid item xs={12} sx={{ margin: "20px 0" }}>
            <Button
              startIcon={<LoginIcon />}
              onClick={() => navigate("/" + NAV.SIGNIN)}
              variant="outlined"
            >
              Inloggen
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Wrapper>
  );
};

export default AccountConfirmation;
